import { render, staticRenderFns } from "./Visitors.vue?vue&type=template&id=2ffc0328"
import script from "./Visitors.vue?vue&type=script&lang=js"
export * from "./Visitors.vue?vue&type=script&lang=js"
import style0 from "./Visitors.vue?vue&type=style&index=0&id=2ffc0328&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports